import { Record } from 'immutable';
const AgentLocator = Record({
  agentType: null,
  agentId: null
}, 'AgentLocator');
export default AgentLocator;